import React from 'react';
import PropTypes from 'prop-types';

const SvgLine = ({ active, ...props }) => {
    const strokeColor = active ? '#ffffff' : '#343A72';
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="none" viewBox="0 0 26 26" {...props}>
            <path
                stroke={strokeColor}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.25"
                d="M1 24.528 24.528 1"
            />
        </svg>
    );
};

SvgLine.propTypes = {
    active: PropTypes.bool,
};
SvgLine.defaultProps = {
    active: false,
};

export default SvgLine;
